<template>
    <div class="dark:bg-surface-800 border p-4 rounded-lg">
        <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold">{{ $t('Invoice Settings & Taxes') }}</h3>
            <div class="flex gap-2">
                <Button
                    :label="$t('New Tax')"
                    icon="pi pi-plus"
                    severity="secondary"
                    size="small"
                    @click="$emit('add-custom-tax')"
                />
                <Button
                    :label="$t('Select Tax')"
                    icon="pi pi-list"
                    severity="success"
                    size="small"
                    @click="$emit('add-predefined-tax')"
                />
            </div>
        </div>

        <div v-if="selectedInvoiceTaxes && selectedInvoiceTaxes.length > 0" class="space-y-3">
            <div
                v-for="(tax, index) in selectedInvoiceTaxes"
                :key="index"
                class="grid grid-cols-12 gap-3 p-3 bg-white dark:bg-surface-700 rounded border items-center"
            >
                <div class="col-span-4">
                    <label class="block text-sm font-medium mb-1">{{ tax.setting?.key || 'Setting' }}</label>
                    <small class="text-xs text-surface-500">{{ tax.setting?.description }}</small>
                </div>
                
                <div class="col-span-3">
                    <InputNumber
                        :modelValue="tax.value"
                        @update:modelValue="(val) => $emit('update-tax-value', index, val)"
                        :suffix="tax.setting?.type === 'percentage' ? '%' : (' ' + tax.setting?.currency)"
                        :step="tax.setting?.type === 'percentage' ? 0.01 : 1"
                        :minFractionDigits="2"
                        :maxFractionDigits="2"
                        class="w-full"
                    />
                </div>
                
                <div class="col-span-3">
                    <Badge 
                        :value="tax.setting?.group" 
                        :severity="tax.setting?.group === 'fees' ? 'warning' : 'info'"
                    />
                </div>
                
                <div class="col-span-2 text-right">
                    <Button
                        icon="pi pi-trash"
                        severity="danger"
                        size="small"
                        text
                        @click="$emit('remove-tax', index)"
                    />
                </div>
            </div>
        </div>
        
        <div v-else class="text-center py-4 text-surface-500">
            {{ $t('No invoice settings selected. Click "Add Setting" to add taxes and fees.') }}
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    selectedInvoiceTaxes: {
        type: Array,
        default: () => []
    }
});

defineEmits(['add-custom-tax', 'add-predefined-tax', 'update-tax-value', 'remove-tax']);
</script>